// ============================================================
// ConfirmationDialog (Compact Delete Dialog)
// ============================================================

import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import { X } from 'lucide-react';

export function ConfirmationDialog({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Delete',
  cancelText = 'Cancel',
  variant = 'danger',
  confirmColor,
  loading = false,
}) {
  const isErrorVariant = variant === 'danger' || confirmColor === 'error' || variant === 'warning';

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          p: 0.5,
          boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
        },
      }}
    >
      <DialogTitle sx={{ pb: 0.5, pt: 1.5, px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="subtitle2" fontWeight={700} color="text.primary">
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose} disabled={loading}>
          <X size={16} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ py: 1, px: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1, gap: 1 }}>
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          onClick={onClose}
          disabled={loading}
          sx={{ borderRadius: 1.5, px: 2, py: 0.5, textTransform: 'none', fontSize: '0.8125rem' }}
        >
          {cancelText}
        </Button>
        <Button
          size="small"
          variant="contained"
          color={isErrorVariant ? 'error' : 'primary'}
          onClick={onConfirm}
          disabled={loading}
          sx={{ borderRadius: 1.5, fontWeight: 600, px: 2.5, py: 0.5, textTransform: 'none', fontSize: '0.8125rem' }}
        >
          {loading ? 'Processing...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
